/**
 * Viñedo — scroll reveal (reveal-left / reveal-right).
 */
(function () {
  /**
   * @param {ParentNode} scope
   */
  function initVinedoReveals(scope) {
    /**
     * @param {IntersectionObserverEntry[]} entries
     * @param {IntersectionObserver} observer
     */
    function activate(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-active');
          observer.unobserve(entry.target);
        }
      });
    }

    const defaultObserver = new IntersectionObserver(activate, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
    });

    scope.querySelectorAll('.vinedo-reveal:not(.vinedo-visual-intro__media)').forEach((el) => {
      if (el.dataset.vinedoRevealInit === 'true') return;
      el.dataset.vinedoRevealInit = 'true';
      defaultObserver.observe(el);
    });

    scope.querySelectorAll('.vinedo-visual-intro__media.vinedo-reveal').forEach((el) => {
      if (el.dataset.vinedoRevealInit === 'true') return;
      el.dataset.vinedoRevealInit = 'true';
      new IntersectionObserver(activate, {
        threshold: 0.15,
        rootMargin: '0px 0px -38% 0px',
      }).observe(el);
    });
  }

  function initAll() {
    initVinedoReveals(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-vinedo-reveal-init]').forEach((el) => {
      delete el.dataset.vinedoRevealInit;
    });
    initVinedoReveals(event.target);
  });
})();
